module.exports = __webpack_public_path__ + "static/img/item6.62352fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item6.png
// module id = 1TEu
// module chunks = 0